<template>
  <Header
    leftArrow
    :leftText="''"
    @leftClick="onClickLeft"
    @onRefreshClick="onRefresh"
    :rightIcons="true"
    pageTitle="AI分析状態確認"
  />
  <div class="home_notice-search">
    <form method="get" style="margin-top: 20px">
      <input
        v-model="searchForm.name"
        type="search"
        name="search"
        placeholder="ユーザーを検索"
      />
      <input
        type="submit"
        onclick="return false;"
        name="submit"
        value="検索"
        @click="getDoctorMembers"
      />
    </form>
    <div
      class="search-btn search-btn_user"
      @click="isSearchDialog = true"
      style="margin-top: 20px"
    >
      <span>並び替え</span>
    </div>
  </div>

  <section style="padding: 15px">
    <van-row justify="space-between">
      <van-col
        v-for="member in doctorMembers"
        span="11"
        style="padding-bottom: 20px"
        @click="onViewPatientDetail(member)"
      >
        <van-row
          justify="center"
          align="center"
          :style="{
            width: '100%',
            height: '70px',
            backgroundColor: 'white',
            marginBottom: '10px',
            border: `2px solid ${getBorder(member.ai_status)}`,
          }"
        >
          <span v-if="member.ai_status == '0'">{{ getStatus(member.ai_status) }}</span>
          <span v-else-if="member.ai_status == '1'">{{ getStatus(member.ai_status) }}</span>
          <img v-else-if="member.ai_status == '2'" src="@/assets/img/ai/status_2.svg" style="width: 100%;height: 100%;"/>
          <img v-else-if="member.ai_status == '3'" src="@/assets/img/ai/status_3.svg" style="width: 100%;height: 100%;"/>
          <img v-else-if="member.ai_status == '4'" src="@/assets/img/ai/status_4.svg" style="width: 100%;height: 100%;"/>
          <img v-else-if="member.ai_status == '5'" src="@/assets/img/ai/status_5.svg" style="width: 100%;height: 100%;"/>
          <img v-else-if="member.ai_status == '6'" src="@/assets/img/ai/status_6_white.svg" style="width: 100%;height: 100%;"/>
<!--          {{ getStatus(member.ai_status) }}-->
        </van-row>
        <van-row  align="center">
          <section
            style="
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            "
          >
            {{ member.name }}
          </section>
          <section
            style="
              width: 6px;
              height: 6px;
              border-radius: 3px;
              background: #00a900;
              margin-left: 5px;
            "
            v-if="member.online_status"
          />
        </van-row>
      </van-col>
    </van-row>
  </section>
  <van-dialog
    v-model:show="isSearchDialog"
    title="並び替え"
    @confirm="getDoctorMembers"
  >
    <div id="search-modal ">
      <div class="search-modal_inner">
        <div class="search-modal_list">
          <van-radio-group v-model="searchForm.status">
            <van-radio style="padding: 5px 0" name="7" icon-size="24px">すべて</van-radio>
            <van-radio style="padding: 5px 0" name="0" icon-size="24px">無効</van-radio>
            <van-radio style="padding: 5px 0" name="1" icon-size="24px">有効</van-radio>
            <van-radio style="padding: 5px 0" name="2" icon-size="24px">臥床</van-radio>
            <van-radio style="padding: 5px 0" name="3" icon-size="24px">長座位</van-radio>
            <van-radio style="padding: 5px 0" name="4" icon-size="24px">端座位</van-radio>
            <van-radio style="padding: 5px 0" name="5" icon-size="24px">離床</van-radio>
            <van-radio style="padding: 5px 0" name="6" icon-size="24px">転倒</van-radio>
          </van-radio-group>
          <p class="search-modal_title-sub">詳細設定</p>
          <van-checkbox v-model="searchForm.abcSort" icon-size="24px"
            >あいうえお順</van-checkbox
          >
        </div>
      </div>
    </div>
  </van-dialog>
  <Overlay :isOverlay="isOverlay" />
</template>
<script setup>
import { onMounted, onUnmounted, reactive, ref } from "vue";
import Header from "@/components/Header.vue";
import Overlay from "@/components/Overlay.vue";
import { showAIMonitorStatus, verifyPatientMonitor } from "@/services";
import { GetPatientDetails } from "@/services/patient";
import { Toast } from "vant";
import {getAIStatusName} from "@/utils/getName";
const emit = defineEmits(["monitor"]);
const searchForm = reactive({
  name: "",
  status: "7",
  abcSort: false,
});
const isOverlay = ref(false);
const isSearchDialog = ref(false);
const doctorMembers = ref();
const timer = ref(null);

const onClickLeft = () => {
  history.back();
};
const onRefresh = () => {
  Toast.loading({
    message: "",
    forbidClick: true,
    duration: 1000,
  });
};
const getBorder = (num) => {
  switch (num) {
    case "0":
      return "grey";
    case "1":
      return "green";
    case "2":
    case "3":
    case "4":
    case "5":
      return "yellow";
    case "6":
      return "red";
  }
};

const getStatus = (num) => {
  return getAIStatusName(num);
};
const getDoctorMembers = async (isLoading = true) => {
  if (isLoading) isOverlay.value = true;

  try {
    const userId = JSON.parse(
      localStorage.getItem(process.env.VUE_APP_USER_KEY)
    )?.login_account_id;
    if (!userId) return;
    const {
      data: { data },
    } = await showAIMonitorStatus({
      user_id: userId,
      name: searchForm.name,
      status: searchForm.status,
    });
    if (searchForm.abcSort) {
      const kanaOrder = new Map([
        ["あ", 0],
        ["い", 1],
        ["う", 2],
        ["え", 3],
        ["お", 4],
        ["か", 5],
        ["き", 6],
        ["く", 7],
        ["け", 8],
        ["こ", 9],
        ["さ", 10],
        ["し", 11],
        ["す", 12],
        ["せ", 13],
        ["そ", 14],
        ["た", 15],
        ["ち", 16],
        ["つ", 17],
        ["て", 18],
        ["と", 19],
        ["な", 20],
        ["に", 21],
        ["ぬ", 22],
        ["ね", 23],
        ["の", 24],
        ["は", 25],
        ["ひ", 26],
        ["ふ", 27],
        ["へ", 28],
        ["ほ", 29],
        ["ま", 30],
        ["み", 31],
        ["む", 32],
        ["め", 33],
        ["も", 34],
        ["や", 35],
        ["ゆ", 36],
        ["よ", 37],
        ["ら", 38],
        ["り", 39],
        ["る", 40],
        ["れ", 41],
        ["ろ", 42],
        ["わ", 43],
        ["を", 44],
        ["ん", 45],
      ]);
      doctorMembers.value = data.sort((x, y) => {
        const xKana = x.name && x.name.charAt(0);
        const yKana = y.name && y.name.charAt(0);
        const xIndex =
          kanaOrder.get(xKana) !== undefined
            ? alphabetIndex.get(xKana)
            : Infinity;
        const yIndex =
          kanaOrder.get(yKana) !== undefined
            ? alphabetIndex.get(yKana)
            : Infinity;
        return xIndex - yIndex;
      });
    } else {
      doctorMembers.value = data;
    }
  } catch (error) {
    console.error(error);
  } finally {
    if (isLoading) isOverlay.value = false;
  }
};
const onViewPatientDetail = async ({ patient_id }) => {
  try {
    const {data: { data }} = await GetPatientDetails(patient_id);
    if (data?.detail) {
      const { detail } = data;
      if (detail) {
        if (detail.online_status !== "online") {
          Toast("相手はオンラインではありません。");
        } else if (detail.monitor_status !== "monitored" && detail.monitor_open_flg !== "1") {
          Toast("相手方の見守権限がオープンしていません。");
        } else if (detail.calling_status != "3" && detail.calling_status != "6") {
          Toast("相手方は現在通話中。");
        } else {
          emit("monitor", {
            toPage: "monitor",
            method: "openPatientMonitor",
            patient_id: detail.patient_id,
            id: detail.id,
            ai_mode: true,
          });
        }
      } else {
        Toast("データ異常。");
      }
    }
  } catch (error) {
    console.error(error);
  }
};

onMounted(async () => {
  try {
    await getDoctorMembers();
    if (timer.value) clearInterval(timer.value);
    timer.value = setInterval(async () => {
      await getDoctorMembers(false);
    }, 5000);
  } catch (error) {
    console.error(error);
  }
});

onUnmounted(() => {
  if (timer.value) clearInterval(timer.value);
});
</script>
